export default {
    indexIntegration:                   { method: 'get',    url: 'integrations' },
    storeIntegration:                   { method: 'post',   url: 'integrations' },
    updateIntegration:                  { method: 'put',    url: 'integrations/{id}'},
    destroyIntegration:                 { method: 'delete', url: 'integrations/{id}'},
    indexIntegrationItemsInstitution:   { method: 'get', url: 'integrations/institution/items'},
    indexIntegrationItems:              { method: 'get', url: 'integrations/items'},
    indexIntegrationProcessItemsType:   { method: 'get', url: 'integrations/process/{integration_item_id}/items'},
    updateIntegrationProcessItemsType:  { method: 'put', url: 'integrations/process/items'}
}